














































































































































































































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Watch,
    Prop
} from "vue-property-decorator";
import {
    API_URL
} from "../global";
import {
    pageDataType,
    SocialItem,
    MainMenuItem,
    RmainMenuItem
} from "../types";
import HomePage from "./HomePage.vue";
import ApexBasicPage from "./ApexBasicPage.vue";
import BrandPage from "./BrandPage.vue";
import CampaignIndexPage from "./CampaignIndexPage.vue";
import CampaignDetailPage from "./CampaignDetailPage.vue";
import JobIndexPage from "./JobIndexPage.vue";
import JobDescriptionPage from "./JobDescriptionPage.vue";
import ContactPage from './ContactPage.vue';
import InvestorPage from './InvestorPage.vue';
import NewsAndUpdateDetailPage from './NewsAndUpdateDetailPage.vue';
import NewsAndUpdateIndexPage from './NewsAndUpdateIndexPage.vue';
import NewsAndUpdateCategory from './NewsAndUpdateCategory.vue';
import {
    FETCH_MAIN_MENU,
    FETCH_RMAIN_MENU,
    FETCH_SOCIAL
} from "../store/actions.names";
import axios from "axios";
import JobForm from './JobForm.vue';
import DynamicLink from '../components/DynamicLink.vue';
import {
    ADD_ANIMATION
} from "../store/mutations.names";
import {
    TimelineMax,
    TweenLite,
    Power1,
    Power2,
    Cubic,
    Power4,
    TweenMax,
    Elastic,
    Linear,
    Back,
    SlowMo,
    Sine,
    Expo,
    Power3
} from "gsap";
import {
    SET_PRELOADER_LOADED,
    SET_MENU_LOADED
} from "../store/mutations.names";

@Component({
    name: "Page",
    components: {
        HomePage,
        ApexBasicPage,
        BrandPage,
        CampaignIndexPage,
        CampaignDetailPage,
        JobIndexPage,
        JobDescriptionPage,
        ContactPage,
        InvestorPage,
        NewsAndUpdateDetailPage,
        NewsAndUpdateIndexPage,
        NewsAndUpdateCategory,
        JobForm,
        DynamicLink

    },
    //     beforeRouteEnter (to, from, next) {
    //     // called before the route that renders this component is confirmed.
    //     // does NOT have access to `this` component instance,
    //     // because it has not been created yet when this guard is called!
    //     console.log("entered");
    //         if (this.mobileMenuIsActive == true){
    //             this.mobileMenuToggle();
    //             this.resetTrail();
    //         }
    //         next();
    //   },

    beforeRouteUpdate(to: any, from: any, next: any) {
    //  console.log("updated");
    //      let d: any = document;
    //      const load = d.querySelectorAll('.loading');
    //      load.style.display = 'none';       
        if ((this as any).mobileMenuIsActive == true) {
            (this as any).mobileMenuToggle();
            (this as any).resetTrail();
        }
        next();
    }
})
export default class Page extends Vue {
    @Getter("mainMenu") public mainMenu!: MainMenuItem[];
    @Getter("rmainMenu") public rmainMenu!: RmainMenuItem[];
    @Getter("pageData") public originalPageData!: pageDataType;
    @Getter("pageType") public originalPageType!: string | null;
    @Action(FETCH_MAIN_MENU) public[FETCH_MAIN_MENU]: any;
    @Action(FETCH_RMAIN_MENU) public[FETCH_RMAIN_MENU]: any;
    @Mutation(SET_PRELOADER_LOADED) public[SET_PRELOADER_LOADED]: any;
    @Mutation(SET_MENU_LOADED) public[SET_MENU_LOADED]: any;
    @Getter("isPreloaderLoaded") public preloaderLoaded!: boolean;
    @Getter("isMenuLoaded") public MenuLoaded!: boolean;
    @Getter("socialIcon") public socialIcon!: SocialItem[];
    @Action(FETCH_SOCIAL) public[FETCH_SOCIAL]: any;

    data() {
        return {
            ItemIndex: null,
            SubItemIndex: null
        };
    }
    mobileNavTrail: any[] = []
    menuReady: boolean = false;

    backwardToTrail() {
        const subMenu =
            (this.$refs.submenu as HTMLElement) ||
            document.querySelector(".content");
        this.mobileNavTrail.pop();
        if (this.mobileNavTrail.length === 0) {
            subMenu.classList.remove('add-menu');
        } else {
            subMenu.classList.add('add-menu');
        }
    }

    resetTrail() {
        const subMenu =
            (this.$refs.submenu as HTMLElement) ||
            document.querySelector(".content");
        this.$set(this, "mobileNavTrail", []);
        subMenu.classList.remove('add-menu');
    }

    selectIndex(idx: any) {
        (this as any).ItemIndex = idx;
    }
    selectSubIndex(index: any) {
        (this as any).SubItemIndex = index;
    }
    pushToTrail(mitem: any, idx: number) {
        if (mitem.children) {
            this.mobileNavTrail.push(idx)
        }
    }

    get currentMenuLevel() {
        let val = (this as any).mainMenu;

        if (this.mobileNavTrail.length === 0) {
            return val;
        } else {
            for (const menuLevel of this.mobileNavTrail) {
                val = val[menuLevel].children;
            }
            return val;
        }
    }

    get pageType() {
        switch (this.$route.name) {
            case "job-application":
                return "JobForm"
                break;
            case "job-complete":
                return this.originalPageData.completion_page.meta.type.split('.')[1]
            default:
                return this.originalPageType
                break;
        }
        return (this.$route.name === "job-application") ? "JobForm" : this.originalPageType
    }

    get pageData() {
        switch (this.$route.name) {
            case "job-complete":
                return this.originalPageData.completion_page
            default:
                return this.originalPageData
                break;
        }
        return (this.$route.name === "job-application") ? "JobForm" : this.originalPageType
    }

    public show: boolean = false;
    public hover: boolean = false;
    public showing: boolean = false;
    public shown: boolean = false;
    public isDropped: boolean = false;
    public isActive: boolean = false;
    mobileMenuIsActive: boolean = false;
    mobileMenuTL: any | null = null;

    dropIt(idx: number) {
        // this.isDropped = !this.isDropped
        this.isDropped = !this.isDropped
    }
    public handleScroll() {
        let scrollpos;
        let d: any = document;
        const nav = d.querySelector('.navbar-container');

        window.addEventListener('scroll', function () {
            scrollpos = window.scrollY;
            if (scrollpos > 3) {
                nav.classList.add('navbar-fixed');
            } else {
                nav.classList.remove('navbar-fixed');
            }
        });

    }

    // public navanim() {
    //     var navanim = new TimelineMax({
    //         onComplete: () => {
    //             this[SET_MENU_LOADED](true)
    //         }
    //         // delay: 5
    //     });
    //     setTimeout(() => {

    //         navanim
    //             .from(
    //                 ".navbar-logo img",
    //                 0.8, {
    //                     autoAlpha: 0,
    //                     y: 40,
    //                     //delay:1,
    //                     ease: Expo.easeOut,
    //                     clearProps: "all"
    //                 },
    //                 0.05,
    //             )
    //             .staggerFrom(
    //                 ".navbar-nav .nav-item",
    //                 .6, {
    //                     autoAlpha: 0,
    //                     x: 20,
    //                     ease: Expo.easeOut,
    //                     clearProps: "all"
    //                 },
    //                 0.1,
    //             )
    //             .from(
    //                 ".navbar-right li",
    //                 1, {
    //                     autoAlpha: 0,
    //                     x: 20,
    //                     ease: Expo.easeOut,
    //                     clearProps: "all"
    //                 },
    //                 0.5
    //             );
    //     }, 4800);

    // }

    public mbmenu() {
        let d: any = document;
        let box = d.querySelector(".mbmenu");
        const {
            navlist
        } = this.$refs;
        const {
            navlist2
        } = this.$refs;
        //let lists = d.querySelector(".listitem");
        let open = false;
        let tl = new TimelineMax({
            paused: true
        });
        tl.pause();
        tl.fromTo('.mbmenu', .5, {
            y: -2000,
            ease: Linear.easeOut,
        }, {
            y: 0,
            clearProps: "all"
        }, 0.2)
        tl.staggerFrom(navlist, .2, {
            y: 15,
            opacity: 0,
            ease: Linear.easeOut,
            clearProps: "all"
        }, 0.2)
        tl.from(navlist2, .2, {
            y: 15,
            opacity: 0,
            ease: Linear.easeOut,
            clearProps: "all"
        }, '+=0.2');
        this.mobileMenuTL = tl;
        // console.log(elements);
    }

    mobileMenuToggle(evt: any | null = null) {
        if (evt != null) {
            evt.preventDefault()
        }
        let d: any = document;
        let box = d.querySelector(".mbmenu");

        if (this.mobileMenuIsActive === false) {
            this.mobileMenuTL.play();
            box.classList.add("active-submenu");
        }
        if (this.mobileMenuIsActive === true) {
            //  this.mobileMenuTL.clearprops();
            setTimeout(() => {
                box.classList.remove("active-submenu");
            }, 100)

        }
        this.mobileMenuIsActive = !this.mobileMenuIsActive;

    }

    mobileMenuNavigate(mitem: any, idx: number) {
        if (mitem.link === null) {
            if (mitem.children.length) {
                this.pushToTrail(mitem, idx);
                this.addmenu();
            }
        } else {
            if (mitem.link.substring(0, 4).toLowerCase() == "http") {
                window.location.href = mitem.link
            } else {

                this.$router.push(mitem.link)
            }

        }
    }

    addmenu() {

        const subMenu =
            (this.$refs.submenu as HTMLElement) ||
            document.querySelector(".content");
        subMenu.classList.add('add-menu');
    }

    removemenu() {
        let d: any = document;
        let navelm = d.querySelector("#nav-toggle");
        navelm.classList.remove('active');

    }
    created() {
        window.addEventListener('scroll', this.handleScroll);
    }

    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);

    }

    get pageTitle(): string {
        return this.originalPageData ? `${this.pageData.title} | APEX` : "APEX";
    }

    get preloaded(): boolean {
        return sessionStorage.getItem('preloaded') == "true";
    }

    public goToPage(url: string) {
        this.$router.push(url);
    }

    @Watch("pageTitle")
    public handlePageTitleChange(val: any, oldVal: any) {
        document.title = val;
    }

    @Watch("pageData")
    public handlePageDataChange(val: any, oldVal: any) {}

    preload() {

        let tl1 = new TimelineMax({
            onComplete: () => {
                this[SET_PRELOADER_LOADED](true);
                sessionStorage.setItem("preloaded", "true");
            },
            paused: true
        });

        tl1

            .from(".loading-logo", .6, {
                autoAlpha: 0,
                y: 40,
                delay: 0.6,
                opacity: 0,
                visibility: "visible"
            })
            .from(".loaderlogo img", .8, {
                autoAlpha: 0,
                y: 40,
                scale: .95,
                ease: Power1.easeOut,
            })

            .fromTo(
                "#loodingwrap",
                1, {
                    background: "#E71C23",
                    xPercent: -100
                }, {
                    xPercent: 0,
                    clearProps: "all"
                }
            )
            .to("#loodingwrap", 0.1, {
                background: "#000000"
            })
            .from("path", .3, {
                autoAlpha: 0,
                opacity: 0

            }, "+=.2")
            .to(".loading", 1, {
                y: "-100%",
                ease: Power4.easeOut
            }, "-=.3");

        tl1.play();
    }

    @Watch('menuReady')
    handleMenuReadyChange(val: boolean, oldVal: boolean) {
        if (val && (val != oldVal)) {
            this.$nextTick(() => {
                this.mbmenu();
            });
        }
    }
    // @Watch("preloaderLoaded")
    // handlePreloaderLoaded(val: any, oldVal: any) {
    //     if (val && !this.MenuLoaded) {
    //         this.navanim();
    //     }
    // }

    mounted() {

        document.title = this.pageTitle;
        this[FETCH_MAIN_MENU]().then(() => {
            this[FETCH_RMAIN_MENU]().then(() => {
                this.menuReady = true;
            })
        })

        this[FETCH_SOCIAL]();
        //  this.navanim();

    }

}
